import { useMemo } from "react";
import { matchPath, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { FALLBACK_ARTICLE_ID, helpArticles } from "./articles";
import type { HelpArticle } from "./types";

export const findArticleForPath = (pathname: string, isAdmin = false): HelpArticle => {
    const visible = helpArticles.filter((a) => !a.adminOnly || isAdmin);

    const direct = visible.find((article) =>
        article.routes.some((pattern) => matchPath({ path: pattern, end: true }, pathname) !== null)
    );
    if (direct) return direct;

    const segments = pathname.split("/").filter(Boolean);
    while (segments.length > 0) {
        segments.pop();
        const parent = "/" + segments.join("/");
        const parentMatch = visible.find((article) =>
            article.routes.some((pattern) => matchPath({ path: pattern, end: false }, parent) !== null)
        );
        if (parentMatch) return parentMatch;
    }

    return visible.find((a) => a.id === FALLBACK_ARTICLE_ID) ?? visible[0];
};

const useHelpForRoute = (overridePath?: string): HelpArticle => {
    const location = useLocation();
    const pathname = overridePath ?? location.pathname;
    const isAdmin = useSelector((state: RootState) => !!state.user.user?.roles?.includes("ROLE_ADMIN"));
    return useMemo(() => findArticleForPath(pathname, isAdmin), [pathname, isAdmin]);
};

export default useHelpForRoute;
